import React from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import { DndEntity } from '../components/DndEntity';
import WsNotification from './WsNotification';
import useOptionalDefaultSchemaId from '../pages/Formulas/utils/useOptionalDefaultSchemaId';
import { isNil } from 'lodash';

// main-container is used to pick up the container in selenium
// ensure this is available in the DOM for screenshot mode
const Container = styled.main.attrs(() => ({
  id: 'main-container',
}))`
  padding: 16px;
`;

// Render a special layout for Screenshot capture feature
const ScreenshotModeLayout = () => {
  const schemaId = useOptionalDefaultSchemaId();
  if (isNil(schemaId)) {
    return (
      <Container>
        No active Schemas found. Please create or enable at least one schema
      </Container>
    );
  }

  return (
    <Container>
      <DndEntity>
        <Outlet />
      </DndEntity>
      <WsNotification />
    </Container>
  );
};

export default ScreenshotModeLayout;
